import React, { useState } from 'react'
import {
  CCol,
  CNav,
  CNavItem,
  CNavLink,
  CRow,
  CTabContent,
  CTabPane,
} from '@coreui/react-pro'
import { DividendAccruedList } from './widgets/dividendAccruedList'
import { NovaWallet } from './widgets/novaWallet/component'
import { TokensList } from './widgets/tokensList/component'
import { Instalments } from './widgets/instalments/component'

export const NovaClient = () => {
  const [activeClientTab, setActiveClientTab] = useState(1)

  return (
    <div>
      <CRow>
        <CCol xs={10}>
          <CNav variant="pills" role="tablist">
            <CNavItem>
              <CNavLink
                data-tab="novaWallet"
                href="#!"
                active={activeClientTab === 1}
                onClick={() => setActiveClientTab(1)}
              >
                NOVA Wallet
              </CNavLink>
            </CNavItem>
            <CNavItem>
              <CNavLink
                data-tab="novaTokens"
                href="#!"
                active={activeClientTab === 2}
                onClick={() => setActiveClientTab(2)}
              >
                Tokens
              </CNavLink>
            </CNavItem>
            <CNavItem>
              <CNavLink
                data-tab="dividends"
                href="#!"
                active={activeClientTab === 3}
                onClick={() => setActiveClientTab(3)}
              >
                Dividends
              </CNavLink>
            </CNavItem>
            <CNavItem>
              <CNavLink
                data-tab="instalments"
                href="#!"
                active={activeClientTab === 4}
                onClick={() => setActiveClientTab(4)}
              >
                Instalments
              </CNavLink>
            </CNavItem>
          </CNav>
        </CCol>
      </CRow>
      <CTabContent className="pt-3">
        <CTabPane
          data-tab="novaWallet"
          role="tabpanel"
          aria-labelledby="contact-tab"
          visible={activeClientTab === 1}
        >
          {activeClientTab === 1 && <NovaWallet />}
        </CTabPane>
        <CTabPane
          data-tab="novaTokens"
          role="tabpanel"
          aria-labelledby="contact-tab"
          visible={activeClientTab === 2}
        >
          {activeClientTab === 2 && <TokensList />}
        </CTabPane>
        <CTabPane
          data-tab="dividends"
          role="tabpanel"
          aria-labelledby="contact-tab"
          visible={activeClientTab === 3}
        >
          {activeClientTab === 3 && <DividendAccruedList />}
        </CTabPane>
        <CTabPane
          data-tab="instalments"
          role="tabpanel"
          aria-labelledby="contact-tab"
          visible={activeClientTab === 4}
        >
          {activeClientTab === 4 && <Instalments />}
        </CTabPane>
      </CTabContent>
    </div>
  )
}
